import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import moment from "moment";
import { ALL_ITEM_TRANSACTIONS_VIEW_BY_PAGE_QUERY } from "../../../graphql/Items/ItemTransactions.graphql";
import DataTable from "../../../components/DataTable";
import { ITEM_TRANSACTION_COLUMNS } from "./columns";
import PageHeader from "../../../components/PageHeader";
import ItemTransactionFilters from "./ItemTransactionFilters";
import { getFilterState, saveFilterState } from "../../../utils";
import { useCompanyParameters } from "../../../utils/hooks";
import { useAuthorization } from "../../../components/Authorization";
import "./styles.scss";

const DEFAULT_FILTERS = {
  TransDt_gte: new Date().setHours(0, 0, 0, 0) - 1000 * 60 * 60 * 24 * 365,
  Posted: false
};

const ItemTransactionsPage = () => {
  const INITIAL_FILTER_STATE = getFilterState("ITEM_TRANSACTION_FILTERS", {
    ...DEFAULT_FILTERS
  });

  const history = useHistory();

  const { data: params } = useCompanyParameters();
  const [filters, setFilters] = useState({ ...INITIAL_FILTER_STATE });

  const Auth = useAuthorization(["ADMIN", "FLEET", "MGMNT", "FIN"]);

  useEffect(() => {
    // Setting up the default filters on start
    if (!filters) {
      const Filters = {};
      Object.keys(INITIAL_FILTER_STATE).forEach(
        key =>
          (Filters[key] =
            INITIAL_FILTER_STATE[key] && INITIAL_FILTER_STATE[key].value
              ? INITIAL_FILTER_STATE[key].value
              : INITIAL_FILTER_STATE[key])
      );
      // Default 'greater than' date (1 year ago at 12AM)
      setFilters({
        ...Filters,
        TransDt_gte: Filters.TransDt_gte
          ? Filters.TransDt_gte
          : new Date().setHours(0, 0, 0, 0) - 1000 * 60 * 60 * 24 * 365
      });
    }
  }, [filters, INITIAL_FILTER_STATE]);

  const handleSetFilters = inputs => {
    // Clearing filters if is empty and avoid null response from query
    Object.keys(inputs).forEach(
      key =>
        (!inputs[key] || inputs[key] === 0 || inputs[key] === "") &&
        delete inputs[key]
    );

    // Seting up the Filters values
    const Filters = {};
    Object.keys(inputs).forEach(
      key =>
        (Filters[key] =
          inputs[key] && inputs[key].value ? inputs[key].value : inputs[key])
    );
    if (Filters && !Filters.TransDt_gte) {
      // Default 'greater than' date (1 year ago at 12:00AM)
      Filters.TransDt_gte =
        new Date().setHours(0, 0, 0, 0) - 1000 * 60 * 60 * 24 * 365;
    }
    if (Filters && Filters.VendorNameRecIdRef) {
      delete Filters.VendorNameRecIdRef;
      const itemSession = getFilterState("ITEM_TRANSACTION_FILTERS");
      delete itemSession.VendorNameRecIdRef;
      saveFilterState("ITEM_TRANSACTION_FILTERS", itemSession);
    }
    if (Filters.TransTypeRecIdRef && Filters.TransTypeRecIdRef !== "0") {
      Filters.TransTypeRecIdRef = parseInt(Filters.TransTypeRecIdRef);
    } else {
      delete Filters.TransTypeRecIdRef;
    }
    if (Filters.BatchNo) {
      Filters.BatchNo = parseInt(Filters.BatchNo);
    }
    if (!Filters.Posted) {
      Filters.Posted = false;
    }
    setFilters(Filters);
    saveFilterState("ITEM_TRANSACTION_FILTERS", Filters);
  };

  const resetFilters = () =>
    setFilters({
      ...DEFAULT_FILTERS
    });

  const parseFilters = input => {
    const { Unposted, Posted, ...where } = input;
    if (input.TransDt_gte) {
      where.TransDt_gte = moment(input.TransDt_gte)
        .startOf("day")
        .toISOString();
    }
    if (input.TransDt_lte) {
      where.TransDt_lte = moment(input.TransDt_lte)
        .endOf("day")
        .toISOString();
    }

    if (Posted && !Unposted) {
      where.Posted = true;
    } else if (Unposted && !Posted) {
      where.Posted = false;
    }

    return where;
  };

  return (
    <React.Fragment>
      <PageHeader
        FilterComponent={ItemTransactionFilters}
        columns={ITEM_TRANSACTION_COLUMNS(
          false,
          params,
          null,
          null,
          null,
          null,
          Auth
        )}
        filters={parseFilters(filters)}
        name="VW_ItemTransactionsByPage"
        query={ALL_ITEM_TRANSACTIONS_VIEW_BY_PAGE_QUERY}
        resetFilters={resetFilters}
        setFilters={handleSetFilters}
        title="Item Transactions"
        onAddClick={() =>
          history.push("/inventory/item-transactions/0/details/0")
        }
      />
      <DataTable
        isPaginated
        columns={ITEM_TRANSACTION_COLUMNS(
          false,
          params,
          null,
          null,
          null,
          null,
          Auth
        )}
        dataQuery={ALL_ITEM_TRANSACTIONS_VIEW_BY_PAGE_QUERY}
        initialSortBy={[
          { id: "Posted", desc: false },
          {
            id: "CreatedDateTime",
            desc: true
          },
          { id: "TransDt", desc: true }
        ]}
        name="VW_ItemTransactionsByPage"
        where={parseFilters(filters)}
        onRowClick={data =>
          !data.WorkOrderRecIdRef
            ? history.push(
                `/inventory/item-transactions/${
                  data.RecId
                }/details/${data.BatchNo || 0}`
              )
            : history.push(`/fleet/work-orders/${data.WorkOrderRecIdRef}/parts`)
        }
      />
    </React.Fragment>
  );
};

ItemTransactionsPage.propTypes = {};
export default ItemTransactionsPage;
